import { render, staticRenderFns } from "./customerorder.vue?vue&type=template&id=637c0e32&scoped=true&"
import script from "./customerorder.vue?vue&type=script&lang=js&"
export * from "./customerorder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637c0e32",
  null
  
)

export default component.exports